'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combine = exports.parse = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _reactDom = require('react-dom');

var _reactHtmlParser = require('react-html-parser');

var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);

var _uuid = require('uuid');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _getExternalCSS = require('./getExternalCSS');

var _getExternalCSS2 = _interopRequireDefault(_getExternalCSS);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var affix = 'customcomponent';

var getCSSContainer = function getCSSContainer(dom) {
  return ['head', 'body', 'div'].map(function (elem) {
    return (0, _jquery2.default)(elem + ':first', dom);
  }).find(function (elem) {
    return !!elem.length;
  });
};

var preprocessNodes = function preprocessNodes(nodes) {
  return nodes.map(function (node) {
    return node.type === 'tag' && node.name === 'html' ? _extends({}, node, {
      children: node.children.map(function (body) {
        return body.type === 'tag' && body.name === 'body' ? _extends({}, body, {
          attribs: {}
        }) : body;
      })
    }) : node;
  });
};

var transform = function transform(_ref) {
  var parser = _ref.parser,
      data = _ref.data,
      required = _ref.required,
      _ref$direct = _ref.direct,
      direct = _ref$direct === undefined ? false : _ref$direct,
      requiredFn = _ref.requiredFn,
      onGeneration = _ref.onGeneration;
  return function (node) {
    if (node.type !== 'tag') return undefined;
    if (node.name === 'script') return null;
    if (node.name !== 'span' || node.name === 'span' && (!node.attribs.class || !node.attribs.class.endsWith(affix))) return undefined;
    var selector = node.attribs.class.replace(affix, '');
    var actualParse = parser[selector];
    if (!actualParse) return undefined;
    var id = (0, _uuid.v4)();
    var isRequired = required.includes(selector);
    if (isRequired) required[id] = false;
    return actualParse(data, {
      id: id,
      node: node,
      direct: direct,
      required: requiredFn(id, isRequired),
      onGeneration: onGeneration
    });
  };
};

var parse = exports.parse = function parse(html) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$parser = _ref2.parser,
      parser = _ref2$parser === undefined ? {} : _ref2$parser,
      _ref2$data = _ref2.data,
      data = _ref2$data === undefined ? {} : _ref2$data,
      _ref2$direct = _ref2.direct,
      direct = _ref2$direct === undefined ? false : _ref2$direct,
      _ref2$required = _ref2.required,
      required = _ref2$required === undefined ? [] : _ref2$required,
      _ref2$requiredFn = _ref2.requiredFn,
      requiredFn = _ref2$requiredFn === undefined ? function () {
    return function () {};
  } : _ref2$requiredFn,
      _ref2$onGeneration = _ref2.onGeneration,
      onGeneration = _ref2$onGeneration === undefined ? function () {} : _ref2$onGeneration;

  return (0, _reactHtmlParser2.default)(html.split('{{').join("<span class='").split('}}').join(affix + '\'></span>'), {
    preprocessNodes: preprocessNodes,
    transform: transform({
      parser: parser,
      data: data,
      direct: direct,
      required: required,
      requiredFn: requiredFn,
      onGeneration: onGeneration
    })
  });
};

var combine = exports.combine = function combine(dom) {
  var newStyle = (0, _jquery2.default)('<style sally-pdf>' + (0, _getExternalCSS2.default)() + '</style>');
  var container = (0, _jquery2.default)(dom);
  getCSSContainer(container).prepend(newStyle);
  var content = container.html();
  newStyle.remove();
  return content;
};

exports.default = function (html) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$parser = _ref3.parser,
      parser = _ref3$parser === undefined ? {} : _ref3$parser,
      _ref3$data = _ref3.data,
      data = _ref3$data === undefined ? {} : _ref3$data,
      _ref3$direct = _ref3.direct,
      direct = _ref3$direct === undefined ? false : _ref3$direct;

  return new Promise(function (resolve) {
    var reactContainer = (0, _jquery2.default)('<div id="sally-pdf-render" style="width: 100%; position: fixed; top: 0px; left: 0px; opacity: 0; pointer-events: none;"></div>');
    (0, _jquery2.default)('body').append(reactContainer);
    var parsedHtml = parse(html, {
      parser: parser,
      data: data,
      direct: direct
    });
    (0, _reactDom.render)(parsedHtml, reactContainer.get(0), function (dom) {
      var content = combine(reactContainer.get(0));
      reactContainer.remove();
      resolve(content);
    });
  });
};